<template>
  <v-card>
    <v-img
      :src="receipt.ImageURL"
      class="white--text align-end"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      height="200px"
    >
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="viewItem"
        >
          <v-icon>search</v-icon>
        </v-btn>
      </v-card-title>
    </v-img>

    <v-card-text>
      金額: ${{receipt.Amount | amountFormat}}
      <br>
      日期: <span v-if="receipt.Date">{{receipt.Date | dateFormat}}</span>
      <br>
      帳號: {{receipt.BankAccount}}
      <br>
      備註: {{receipt.Remark}}
    </v-card-text>

    <v-card-actions v-if="canEditReceipt">
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="editItem"
      >
        <v-icon>edit</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="confirmDeleteItem"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-card-actions>

    <v-dialog
      scrollable
      v-model="isShowImageDialog"
      max-width="500px"
    >
      <v-img
        :src="receipt.ImageURL"
        contain
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import filterMixin from "@/data/filters/filter-mixin.vue";
export default {
  mixins: [filterMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isShowImageDialog: false
  }),
  computed: {
    receipt() {
      return this.item;
    },
    ...mapGetters(["canEditReceipt"])
  },
  methods: {
    viewItem() {
      this.isShowImageDialog = true;
    },
    editItem() {
      this.$emit("edit", this.item.ID);
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除此發票(金額 $" + (this.item.Amount || "") + ")?"))
        return;
      this.$emit("remove", this.item.ID);
    }
  }
};
</script>